import { ReportTemplateVersion } from 'dashboard/models/report-template-version';
import {
  ReportTemplateVersionActions,
  ReportTemplateVersionActionType,
} from 'dashboard/redux/actions/report-template-version';

export interface ReportTemplateVersionState {
  reportTemplateVersion: ReportTemplateVersion | undefined;
}

export const initialState: ReportTemplateVersionState = {
  reportTemplateVersion: undefined,
};

export default function (
  state: ReportTemplateVersionState = initialState,
  action: ReportTemplateVersionActions,
): ReportTemplateVersionState {
  switch (action.type) {
    case ReportTemplateVersionActionType.SetReportTemplateVersion: {
      return {
        ...state,
        reportTemplateVersion: action.payload.reportTemplateVersion,
      };
    }
    case ReportTemplateVersionActionType.ClearReportTemplateVersion: {
      return {
        ...state,
        reportTemplateVersion: undefined,
      };
    }
    default:
      return state;
  }
}
